export default __webpack_public_path__ + "static/media/twitter.385f96b1.svg";